var React = require('react');

function LocationInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M11.7965 0.738281C7.48407 0.738281 3.97559 4.24676 3.97559 8.55917C3.97559 13.9794 11.8042 23.2383 11.8042 23.2383C11.8042 23.2383 19.6174 13.7129 19.6174 8.55917C19.6174 4.24676 16.109 0.738281 11.7965 0.738281ZM14.1562 10.8491C13.5055 11.4997 12.6511 11.825 11.7965 11.825C10.942 11.825 10.0873 11.4997 9.43689 10.8491C8.1357 9.54808 8.1357 7.43101 9.43689 6.12982C10.067 5.49948 10.9051 5.15231 11.7965 5.15231C12.6879 5.15231 13.5259 5.49962 14.1562 6.12982C15.4574 7.43101 15.4574 9.54808 14.1562 10.8491Z","fill":"white"}));
}

LocationInline.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = LocationInline;

LocationInline.default = LocationInline;
